module.exports = __webpack_public_path__ + "img/system-county-yg.e1bd3085.png";